import { fetchTotals } from "./totalsSlice";

export const fetchAllTiles = (widgets, filters) => (dispatch) => {
    const actions = widgets.flatMap(x => x.fetchActions);
    const uniqueActions = [...new Set(actions), fetchTotals];
    const requests = uniqueActions.map(action => dispatch(action(filters)));

    return {
        abort: () => {
            requests.forEach(req => {
                if (req && typeof req.abort === 'function') {
                    req.abort();
                }
            });
        }
    };
};